import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'

export const StyledTableOfContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .organisation {
    color: ${theme.colors.gray500};
    a,
    a:visited {
      text-decoration: none;
    }
    a[href] {
      color: ${theme.colors.gray500};
      text-decoration: underline;
    }
  }

  --font-weight-lg: ${theme.sizes.fwBold};
  --font-weight-md: ${theme.sizes.fwSemiBold};
  --font-weight-sm: ${theme.sizes.fwRegular};
  &[data-size='lg'] {
    font-size: 18px;
    font-weight: var(--font-weight-lg);
    line-height: 26px;
  }
  &[data-size='md'] {
    font-size: 16px;
    font-weight: var(--font-weight-md);
    line-height: 24px;
  }
  &[data-size='sm'] {
    font-size: 14px;
    font-weight: var(----font-weight-sm);
    line-height: 22px;
  }
`

export const StyledContent = styled.span`
  p {
    color: ${theme.colors.gray500};
  }
`
export const StyledRefContent = styled.a`
  color: ${theme.colors.secondaryBase};
  text-decoration: auto;
`
export const StyledSeparator = styled.span`
  margin: 0 0.4em;
  color: ${theme.colors.neutral300};
`
